import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import apiRequest from "../../functions/api";
import { MenuItem, Grid, Box, Button, TextField, Dialog, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import Autocomplete from "@mui/material/Autocomplete";
import { useMessage } from "../../context/message-context";
import { DateTextField } from "../lib";
import { useSessionStorage } from "../../utils/hooks";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";

function ToDosNew({aufgabenNeuLaden}) {
  const { t } = useTranslation();

  const [accessToken] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const { showErrorMessage, hideMessage, showSuccessMessage } = useMessage();
  const [isLoading, setIsLoading] = useState(false);
  const [mitarbeiter, setMitarbeiter] = useState("");

  //States für Dialog Form
  const [neueAufgabe, setNeueAufgabe] = useState(false);
  const [formValues, setFormValues] = useState({
    aufgabenart: "01",
    mitarbeiterwahl: "",
    BezKurz: "",
    BezLang: "",
    Minuten: "30",
    Termin: "",
    sachverhaltWahl: "N",
    sachverhalt: "",
  });

  useEffect(() => {
    setIsLoading(true);

    const payload = {
      statement: "HOLE_INTERV_DATEN",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "aufgaben", payload, headers, datenCb);
    // eslint-disable-next-line
  }, []);

  const datenCb = (response) => {
    if (response.status === 200) {
      setMitarbeiter(response.data.mitarbeiter);
      setIsLoading(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    const payload = {
      statement: "AUFGABE_ERSTELLEN",
      formData: formValues,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "aufgaben", payload, headers, speichernCb);
  };

  const speichernCb = (response) => {
    setIsLoading(false);
    setNeueAufgabe(false);

    if (response.status === 200) {
      aufgabenNeuLaden()
      showSuccessMessage("Aufgabe erfolgreich angelegt");
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };

  const handleChange = (event, newValue, newName) => {
    const { name, value } = event.target;

    if (name) {
      setFormValues({ ...formValues, [name]: value });
    } else if (newValue?.key) {
      setFormValues({ ...formValues, [newName]: newValue?.key });
    }
  };

  if (isLoading) {
    return <LoadingComponent />;
  }

  return (
    <div>
      <Button fullWidth variant="contained" color="primary" onClick={() => setNeueAufgabe(true)}>
        {t("Neue Aufgabe")}
      </Button>
      <Dialog open={neueAufgabe} maxWidth="md" onClose={() => setNeueAufgabe(false)} fullWidth>
        <DialogContent sx={{ height: "96" }}>
          <DialogContentText style={{ fontSize: 22, fontWeight: "bold" }}>Aufgabe anlegen</DialogContentText>
          <form onSubmit={handleSubmit} id="aufgaben-form">
            <Grid container justifyContent="center">
              <Grid item xs={12} sm={6}>
                <Grid item sm={12}>
                  <Box p={1}>
                    <TextField
                      select
                      id="aufgabenart"
                      name="aufgabenart"
                      label={t("Was möchten Sie anlegen?")}
                      value={formValues.aufgabenart}
                      onChange={handleChange}
                      fullWidth
                      required
                      margin="normal"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    >
                      <MenuItem value="01">{t("Aufgabe an mich selbst")}</MenuItem>
                      {mitarbeiter && <MenuItem value="02">{t("Aufgabe für einen Mitarbeiter")}</MenuItem>}
                    </TextField>
                  </Box>
                </Grid>
                {mitarbeiter && (
                  <Grid item sm={12}>
                    <Box p={1}>
                      <Autocomplete
                        onChange={(event, newValue) => handleChange(event, newValue, "mitarbeiterwahl")}
                        options={mitarbeiter}
                        getOptionLabel={(option) => option.auswahl}
                        defaultValue={mitarbeiter.find((element) => element.key === formValues.mitarbeiterwahl)}                        
                        disabled={formValues?.aufgabenart !== "02"}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={t("Für welchen Mitarbeiter soll die Aufgabe erstellt werden?")}
                            variant="outlined"
                            id="mitarbeiterwahl"
                            name="mitarbeiterwahl"
                            required
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        )}
                      />
                    </Box>
                  </Grid>
                )}
                <Grid item sm={12}>
                  <Box p={1}>
                    <TextField
                      variant="outlined"
                      label={t("Welche Aufgabe soll erledigt werden?")}
                      value={formValues.BezKurz}
                      onChange={handleChange}
                      id="BezKurz"
                      name="BezKurz"
                      fullWidth
                      required
                      margin="normal"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Box>
                </Grid>

                <Grid item sm={12}>
                  <Box p={1}>
                    <TextField
                      variant="outlined"
                      type="number"
                      label={t("Wie lange dauert die Aufgabe in Min (etwa)")}
                      value={formValues.Minuten}
                      onChange={handleChange}
                      id="Minuten"
                      name="Minuten"
                      fullWidth
                      required
                      margin="normal"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Box>
                </Grid>

                <Grid item sm={12}>
                  <Box p={1}>
                    <TextField
                      multiline
                      rows={3}
                      variant="outlined"
                      label={t("Beschreibung")}
                      value={formValues.BezLang}
                      onChange={handleChange}
                      id="BezLang"
                      name="BezLang"
                      fullWidth
                      margin="normal"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Box>
                </Grid>

                <Grid item sm={12}>
                  <Box p={1}>
                    <DateTextField
                      variant="outlined"
                      label={t("Bis wann soll die Aufgabe erledigt werden?")}
                      value={formValues.Termin}
                      onChange={handleChange}
                      id="Termin"
                      name="Termin"
                      fullWidth
                      margin="normal"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Box>
                </Grid>

                {/* <Grid item sm={12}>
                  <Box p={1}>
                    <TextField
                      variant="outlined"
                      label={t("Gibt es zu der Aufgabe einen bestimmten Sachverhalt")}
                      value={formValues.sachverhaltWahl}
                      select
                      onChange={handleChange}
                      id="sachverhaltWahl"
                      name="sachverhaltWahl"
                      defaultValue={"N"}
                      fullWidth
                      margin="normal"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    >
                      <MenuItem key="J" value="J">
                        {t("Ja")}
                      </MenuItem>
                      <MenuItem key="N" value="N">
                        {t("Nein")}
                      </MenuItem>
                    </TextField>
                  </Box>
                </Grid>

                {ablagenamen && (
                  <Grid item sm={12}>
                    <Box p={1}>
                      <Autocomplete
                        onChange={handleChange}
                        options={ablagenamen}
                        disabled={formValues?.sachverhaltWahl !== "J"}
                        getOptionLabel={(option) => option.bez}
                        defaultValue={ablagenamen.find((element) => element.key === formValues.sachverhalt)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={t("Sachverhalte")}
                            variant="outlined"
                            id="sachverhalt"
                            name="sachverhalt"
                            fullWidth
                            required
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        )}
                      />
                    </Box>
                  </Grid>
                )} */}
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button style={{ marginRight: "10px" }} display="flex" onClick={() => setNeueAufgabe(false)}>
            {t("Abbrechen")}
          </Button>
          <Button color="primary" variant="contained" type="submit" form="aufgaben-form">
            {t("Absenden")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default ToDosNew;
